(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MsalAngular", [], factory);
	else if(typeof exports === 'object')
		exports["MsalAngular"] = factory();
	else
		root["MsalAngular"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition